import React from 'react'
import SectionTitle from '../components/section-title'
import NextStepsContent from '../content/next-steps.mdx'

const NextSteps = class extends React.Component {
  render() {
    return (
      <>
        <SectionTitle title="Next steps"></SectionTitle>
        <div style={{ wordBreak: 'break-word' }}>
          <NextStepsContent />
        </div>
      </>
    )
  }
}

export default NextSteps
